import React, { useState } from "react";

const PasswordField = ({ label = "Mot de passe", value, onChange, id = "password" }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => setShowPassword((current) => !current);

    return (
        <div className="mb-3 form-password-toggle">
            <div className="d-flex justify-content-between">
                <label className="form-label" htmlFor={id}>
                    {label}
                </label>
            </div>

            <div className="input-group input-group-merge">
                <input
                    type={showPassword ? "text" : "password"}
                    id={id}
                    className="form-control"
                    name={id}
                    placeholder="••••••••••••"
                    aria-describedby={`${id}-toggle`}
                    value={value}
                    onChange={onChange}
                    required
                />
                <button
                    id={`${id}-toggle`}
                    className="input-group-text cursor-pointer"
                    type="button"
                    onClick={togglePassword}
                    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                    <i className={`bx ${showPassword ? "bx-show" : "bx-hide"}`}></i>
                </button>
            </div>
        </div>
    );
};

export default PasswordField;
